var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h5',[_vm._v(_vm._s(_vm.$t('reportFields')))]),_c('custom-fields',{attrs:{"campaign":_vm.campaign,"is-output-data":true,"title":"campaignReportFields"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }